module.exports = __webpack_public_path__ + "img/home-portada-empresa.91d836e6.svg";